export const questionsENG = [
  {
    id: 1,
    question: 'Your Name:',
    type: 'input',
    placeholder: 'Input your name'
  },
  {
    id: 2,
    question: 'Your Age:',
    type: 'input',
    placeholder: 'Input your age'
  },
  {
    id: 3,
    type: 'options',
    question: 'Ethnicity:',
    options: [
        {
          id: 1,
          text: 'European',
          value: 0
        },
        {
          id: 2,
          text: 'African',
          value: 1
        },
        {
          id: 3,
          text: 'Asian',
          value: 2
        },
        {
          id: 4,
          text: 'Other',
          value: 3
        }
      ],
  },
  {
    id: 4,  
    type: 'options',
    question: 'Your biological sex:',
    options: [
        {
          id: 1,
          text: 'Male',
          value: 0
        },
        {
          id: 2,
          text: 'Female',
          value: 1
        },
      ],
  },
  {
    id: 5,
    type: 'options',
    question: 'How often do you include fruits and vegetables in your diet?',
    options: [
        {
          id: 1,
          text: 'Rarely or never',
          value: 0
        },
        {
          id: 2,
          text: 'A few times a week',
          value: 1
        },
        {
          id: 3,
          text: 'Every day',
          value: 2
        },
        {
          id: 4,
          text: '5 or more times a day',
          value: 3
        }
      ],
    description: 'Based on 16 studies involving over 833,000 participants.',
    impact: 'Research involving 16 studies with more than 833,000 participants shows that each additional daily serving of fruits and vegetables reduces the risk of death from all causes by 5%, with benefits peaking at five servings per day.',
    rate: 74,
    link: 'https://www.bmj.com/content/349/bmj.g4490/',
  },
  {
    id: 6,
    type: 'options',
    question: 'How often do you eat processed foods such as fast food, canned goods, or frozen meals?',
    options: [
        {
          id: 1,
          text: 'Daily',
          value: 0
        },
        {
          id: 2,
          text: 'Several times a week or more',
          value: 1
        },
        {
          id: 3,
          text: 'Once a week',
          value: 2
        },
        {
          id: 4,
          text: 'Rarely or never',
          value: 3
        }
      ],
    description: 'Based on 45 studies with nearly 10 million participants.',
    impact: 'Based on an analysis of 45 studies with nearly 10 million participants, increased consumption of ultra-processed foods is associated with a significant increase in the risk of heart disease, diabetes, and other serious health issues.',
    rate: 34,
    link: 'https://www.bmj.com/content/384/bmj-2023-077310',
  },
  {
    id: 7,
    type: 'options',
    question: 'How often do you consume sugar?',
    options: [
        {
          id: 1,
          text: 'Several times a day',
          value: 0
        },
        {
          id: 2,
          text: 'Daily',
          value: 1
        },
        {
          id: 3,
          text: 'A few treats per week',
          value: 2
        },
        {
          id: 4,
          text: 'None at all',
          value: 3
        }
      ],
    description: 'Based on 73 meta-analyses.',
    impact: 'This issue is based on findings from 73 meta-analyses reviewed in a major study, linking high sugar consumption to an increased risk of various diseases, including certain types of cancer and overall mortality.',
    rate: 34,
    link: 'https://www.bmj.com/content/381/bmj-2022-071609',
  },
  {
    id: 8,
    type: 'options',
    question: 'How much water do you usually drink per day?',
    options: [
        {
          id: 1,
          text: '2–5 glasses',
          value: 0
        },
        {
          id: 2,
          text: '2–5 glasses',
          value: 1
        },
        {
          id: 3,
          text: '6–9 glasses',
          value: 2
        },
        {
          id: 4,
          text: '10 or more glasses',
          value: 3
        }
      ],
    description: 'Based on a systematic review, Nutrients, 2018.',
    impact: 'According to a systematic review published in Nutrients (2018), water consumption is important for metabolism and overall health, but individual needs vary greatly depending on activity level and environmental conditions.',
    rate: 24,
    link: 'https://www.mdpi.com/2072-6643/10/12/1928',
  },
  {
    id: 9,
    type: 'options',
    question: 'How much time do you spend on cardio each week? For example, running, swimming, hiking, etc.?',
    options: [
        {
          id: 1,
          text: 'Rarely or never',
          value: 0
        },
        {
          id: 2,
          text: 'Less than 150 minutes',
          value: 1
        },
        {
          id: 3,
          text: '150–300 minutes',
          value: 2
        },
        {
          id: 4,
          text: 'More than 300 minutes',
          value: 3
        }
      ],
    description: 'Based on 150 reviews, Cochrane, with 485,110 participants.',
    impact: 'According to a review of 150 systematic reviews by Cochrane, involving 485,110 participants, regular cardio exercise is associated with a 13% reduction in mortality.',
    rate: 53,
    link: 'https://bmcpublichealth.biomedcentral.com/articles/10.1186/s12889-020-09855-3',
  },
  {
    id: 10,
    type: 'options',
    question: 'How often do you do strength training?',
    options: [
        {
          id: 1,
          text: 'Rarely or never',
          value: 0
        },
        {
          id: 2,
          text: 'Less than once a week',
          value: 1
        },
        {
          id: 3,
          text: '1–2 days per week',
          value: 2
        },
        {
          id: 4,
          text: 'More than 2 days per week',
          value: 3
        }
      ],
    description: 'Based on 16 studies',
    impact: 'According to a systematic review and meta-analysis of 16 studies, performing strength-training exercises reduces the risk of major non-communicable diseases and overall mortality by 10-17%.',
    rate: 34,
    link: 'https://bjsm.bmj.com/content/56/13/755',
  },
  {
    id: 11,
    type: 'options',
    question: 'How often do you practice yoga or stretching?',
    options: [
        {
          id: 1,
          text: 'Never',
          value: 0
        },
        {
          id: 2,
          text: 'A few times a month',
          value: 1
        },
        {
          id: 3,
          text: '1–2 times a week',
          value: 2
        },
        {
          id: 4,
          text: '3 or more times a week',
          value: 3
        }
      ],
    description: 'Based on 22 studies.',
    impact: 'According to a meta-analysis of 22 studies, yoga significantly improves physical fitness and overall health, which can contribute to longevity by enhancing balance, flexibility, and strength.',
    rate: 15,
    link: 'https://ijbnpa.biomedcentral.com/articles/10.1186/s12966-019-0789-2',
  },
  {
    id: 12,
    type: 'options',
    question: 'How much time do you spend sitting each day?',
    options: [
        {
          id: 1,
          text: 'More than 8 hours',
          value: 0
        },
        {
          id: 2,
          text: '4–8 hours',
          value: 1
        },
        {
          id: 3,
          text: '2–4 hours',
          value: 2
        },
        {
          id: 4,
          text: 'Less than 2 hours',
          value: 3
        }
      ],
    description: 'Based on 47 studies',
    impact: 'According to a systematic review and meta-analysis of 47 studies, a sedentary lifestyle increases the risk of cardiovascular diseases, cancer, and type 2 diabetes.',
    rate: 34,
    link: 'https://pubmed.ncbi.nlm.nih.gov/25599350/',
  },
  {
    id: 13,
    type: 'options',
    question: 'How frequently do you get more than 7 hours of sleep?',
    options: [
        {
          id: 1,
          text: 'Never',
          value: 0
        },
        {
          id: 2,
          text: '1–2 nights per week',
          value: 1
        },
        {
          id: 3,
          text: '3–4 nights per week',
          value: 2
        },
        {
          id: 4,
          text: '5 or more nights per week',
          value: 3
        }
      ],
    description: 'Based on 16 studies with 1.3 million participants.',
    impact: 'According to a systematic review of 16 studies involving over 1.3 million people, healthy sleep helps reduce the risk of overall mortality by 24% and decreases the risk of cardiovascular diseases by 20%.',
    rate: 100,
    link: 'https://academic.oup.com/sleep/article/33/5/585/2454478',
  },
  {
    id: 14,
    type: 'options',
    question: 'How often do you have difficulty falling or staying asleep?',
    options: [
        {
          id: 1,
          text: '5 or more nights per week',
          value: 0
        },
        {
          id: 2,
          text: '3–4 nights per week',
          value: 1
        },
        {
          id: 3,
          text: '1–2 nights per week',
          value: 2
        },
        {
          id: 4,
          text: 'Never',
          value: 3
        }
      ],
    description: 'Based on a review of 85 meta-analyses.',
    impact: 'According to a review of 85 meta-analyses, poor sleep quality can lead to adverse health outcomes, including diabetes, obesity, cardiovascular diseases, and overall mortality.',
    rate: 62,
    link: 'https://www.frontiersin.org/journals/medicine/articles/10.3389/fmed.2021.813943/full',
  },
  {
    id: 15,
    type: 'options',
    question: 'How often do you spend time with friends or family?',
    options: [
        {
          id: 1,
          text: 'Never',
          value: 0
        },
        {
          id: 2,
          text: 'A few times a month',
          value: 1
        },
        {
          id: 3,
          text: 'Weekly',
          value: 2
        },
        {
          id: 4,
          text: 'Daily',
          value: 3
        }
      ],
    description: 'Based on a study by Harvard Adult Development School.',
    impact: 'According to an analysis of 23 meta-analyses, strong social support significantly improves health and longevity, reducing the risk of diseases and mortality.',
    rate: 41,
    link: 'https://www.frontiersin.org/journals/psychology/articles/10.3389/fpsyg.2021.717164/full',
  },
  {
    id: 16,
    type: 'options',
    question: 'What is your current relationship status?',
    options: [
        {
          id: 1,
          text: 'Divorced/Widowed/Separated',
          value: 0
        },
        {
          id: 2,
          text: 'Single',
          value: 1
        },
        {
          id: 3,
          text: 'Married',
          value: 2
        },
        {
          id: 4,
          text: 'In a long-term relationship',
          value: 3
        }
      ],
    description: 'Based on 148 studies, over 300,000 participants',
    impact: 'A meta-analysis of 148 studies involving over 300,000 people shows that family status has a significant impact on health.',
    rate: 74,
    link: 'https://journals.plos.org/plosmedicine/article?id=10.1371/journal.pmed.1000316',
  },
  {
    id: 17,
    type: 'options',
    question: 'Do you have children?',
    options: [
        {
          id: 1,
          text: 'No, and I don’t plan to',
          value: 0
        },
        {
          id: 2,
          text: 'No, but I plan to',
          value: 1
        },
        {
          id: 3,
          text: 'Yes, living at home',
          value: 2
        },
        {
          id: 4,
          text: 'Yes, not living at home',
          value: 3
        }
      ],
    description: 'Based on a meta-analysis of 17 studies.',
    impact: 'A meta-analysis of 17 studies shows that having children affects health by providing benefits such as social support and emotional well-being but also causing stress and lifestyle challenges.',
    rate: 74,
    link: 'https://link.springer.com/article/10.1007/s10680-018-9469-1',
  },
  {
    id: 18,
    type: 'options',
    question: 'Does your social circle support you when you need help?',
    options: [
        {
          id: 1,
          text: 'No',
          value: 0
        },
        {
          id: 2,
          text: 'A little',
          value: 1
        },
        {
          id: 3,
          text: 'Enough',
          value: 2
        },
        {
          id: 4,
          text: 'Fully',
          value: 3
        }
      ],
    description: 'Based on 39 studies and 140 meta-analyses.',
    impact: 'Based on the findings of the Harvard Study of Adult Development, strong social connections are associated with improved physical health, greater happiness, and a longer life.',
    rate: 74,
    link: 'https://www.adultdevelopmentstudy.org',
  },
  {
    id: 19,
    type: 'options',
    question: 'How many alcoholic drinks do you drink in a week?',
    options: [
        {
          id: 1,
          text: '15 or more drinks per week',
          value: 0
        },
        {
          id: 2,
          text: '8–14 drinks per week',
          value: 1
        },
        {
          id: 3,
          text: '1–7 drinks per week',
          value: 2
        },
        {
          id: 4,
          text: 'I don’t drink',
          value: 3
        }
      ],
    description: 'Based on 107 studies involving 4.8 million participants',
    impact: 'The analysis published in BMC Medicine indicates that regular and excessive consumption of alcoholic beverages significantly increases the risk of developing cardiovascular diseases, liver diseases, and certain types of cancer.',
    rate: 74,
    link: 'https://bmcmedicine.biomedcentral.com/articles/10.1186/s12916-021-02040-2',
  },
  {
    id: 20,
    type: 'options',
    question: 'Do you use nicotine (cigarettes, vapes, smokeless tobacco)?',
    options: [
        {
          id: 1,
          text: 'I use daily',
          value: 0
        },
        {
          id: 2,
          text: 'I use occasionally',
          value: 1
        },
        {
          id: 3,
          text: 'I used to use',
          value: 2
        },
        {
          id: 4,
          text: 'I’ve never used',
          value: 3
        }
      ],
    description: 'Based on a meta-analysis by the U.S. National Cancer Institute.',
    impact: 'A meta-analysis conducted by the U.S. National Cancer Institute shows that smoking significantly increases the risks of cancer, cardiovascular diseases, stroke, and lung diseases.',
    rate: 74,
    link: 'https://www.cancer.gov/about-cancer/causes-prevention/risk/tobacco/cessation-fact-sheet',
  },
  {
    id: 21,
    type: 'options',
    question: 'How often do you feel stress in daily life?',
    options: [
        {
          id: 1,
          text: 'Almost always',
          value: 0
        },
        {
          id: 2,
          text: 'Often',
          value: 1
        },
        {
          id: 3,
          text: 'Sometimes',
          value: 2
        },
        {
          id: 4,
          text: 'Rarely or occasionally',
          value: 3
        }
      ],
    description: 'Based on a study with 10,000 participants.',
    impact: 'Studies involving more than 10,000 people show that chronic psychological stress significantly harms health, promotes increased inflammation, and accelerates cellular aging, increasing disease and mortality risks.',
    rate: 74,
    link: 'https://bmcpublichealth.biomedcentral.com/articles/10.1186/1471-2458-14-9',
  },
  {
    id: 22,
    type: 'options',
    question: 'How negatively does your mental health impact your well-being?',
    options: [
        {
          id: 1,
          text: 'Significantly',
          value: 0
        },
        {
          id: 2,
          text: 'Moderately',
          value: 1
        },
        {
          id: 3,
          text: 'Mildly',
          value: 2
        },
        {
          id: 4,
          text: 'Not at all',
          value: 3
        }
      ],
    description: 'Based on 10 cohort studies involving 68,222 participants.',
    impact: 'A study involving 68,222 participants across 10 large cohort studies shows that even low levels of psychological stress significantly increase the risk of death from all causes.',
    rate: 74,
    link: 'https://www.bmj.com/content/345/bmj.e4933',
  },
  {
    id: 23,
    type: 'options',
    question: 'How often do you have general medical check-ups?',
    options: [
        {
          id: 1,
          text: 'Never',
          value: 0
        },
        {
          id: 2,
          text: 'Every 5 years',
          value: 1
        },
        {
          id: 3,
          text: 'Every 2–3 years',
          value: 2
        },
        {
          id: 4,
          text: 'Annually',
          value: 3
        }
      ],
    description: 'Based on 14 studies involving 182,880 participants',
    impact: 'Исследования, основанные на 14 экспериментах с участием 182 880 человек, показывают, что регулярные медицинские осмотры полезны для профилактики заболеваний, ранней диагностики и общего управления здоровьем.',
    rate: 74,
    link: 'https://www.bmj.com/content/345/bmj.e7191',
  },
  {
    id: 24,
    type: 'options',
    question: 'How often do you undergo recommended cancer screenings?',
    options: [
        {
          id: 1,
          text: 'Never',
          value: 0
        },
        {
          id: 2,
          text: '1-2 times a year',
          value: 1
        },
        {
          id: 3,
          text: 'Less than once a year',
          value: 2
        },
        {
          id: 4,
          text: 'As recommended by your doctor',
          value: 3
        }
      ],
    description: 'Based on 18 randomized clinical trials involving 2.1 million participants.',
    impact: 'Studies based on 18 long-term randomized clinical trials involving 2.1 million people show that screening for colorectal, prostate, and lung cancer can increase life expectancy.',
    rate: 74,
    link: 'https://jamanetwork.com/journals/jamainternalmedicine/article-abstract/2808648',
  },
  {
    id: 25,
    type: 'options',
    question: 'What is the average lifespan of your biological grandparents, or their current age if alive?',
    options: [
        {
          id: 1,
          text: 'Less than 70',
          value: 0
        },
        {
          id: 2,
          text: '70-79',
          value: 1
        },
        {
          id: 3,
          text: '80-89',
          value: 2
        },
        {
          id: 4,
          text: '90+',
          value: 3
        }
      ],
    description: 'Based on a meta-analysis of factors influencing life expectancy.',
    impact: 'A widely cited meta-analysis suggests that genetic factors significantly influence human longevity, while the lifespan of grandparents has a noticeable impact on their descendants.',
    rate: 74,
    link: 'https://www.intechopen.com/chapters/55982',
  },
  {
    id: 26,
    type: 'options',
    question: 'How would you describe your current weight',
    options: [
        {
          id: 1,
          text: 'Obese',
          value: 0
        },
        {
          id: 2,
          text: 'Overweight',
          value: 1
        },
        {
          id: 3,
          text: 'Slightly overweight',
          value: 2
        },
        {
          id: 4,
          text: 'No',
          value: 3
        }
      ],
    description: 'Based on 230 cohort studies involving 30.3 million participants.',
    impact: 'Are you overweighted?',
    rate: 74,
    link: 'https://www.bmj.com/content/353/bmj.i2156',
  },
  {
    id: 27,
    type: 'options',
    question: 'What is your usual blood pressure?',
    options: [
        {
          id: 1,
          text: '140/90 or higher (High)',
          value: 0
        },
        {
          id: 2,
          text: '120/80 to 139/89 (Elevated)',
          value: 1
        },
        {
          id: 3,
          text: 'Below 120/80 (Normal)',
          value: 2
        },
        {
          id: 4,
          text: 'I don’t know',
          value: 3
        }
      ],
    description: 'Based on 61 studies involving over 1 million participants.',
    impact: 'A meta-analysis of 61 studies involving more than 1 million people demonstrates that high blood pressure significantly increases the risk of cardiovascular diseases, stroke, and mortality.',
    rate: 74,
    link: 'https',
  },
  {
    id: 28,
    type: 'options',
    question: 'What is your "bad" (LDL) cholesterol level?',
    options: [
        {
          id: 1,
          text: '160 mg/dL or higher (High)',
          value: 0
        },
        {
          id: 2,
          text: '100–159 mg/dL (Above average)',
          value: 1
        },
        {
          id: 3,
          text: 'Below 100 mg/dL (Optimal)',
          value: 2
        },
        {
          id: 4,
          text: 'I don’t know',
          value: 3
        }
      ],
    description: 'Based on 74 studies involving 2.5 million participants.',
    impact: 'Studies from 74 research papers involving over 2.5 million people show that cardiovascular diseases significantly shorten life expectancy, reducing it by several years on average.',
    rate: 74,
    link: 'https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0284052',
  },
  {
    id: 29,
    type: 'options',
    question: 'What is your fasting blood glucose level?',
    options: [
        {
          id: 1,
          text: '126 mg/dL or higher (Diabetes)',
          value: 0
        },
        {
          id: 2,
          text: '100–125 mg/dL (Prediabetes)',
          value: 1
        },
        {
          id: 3,
          text: 'Below 100 mg/dL (Normal)',
          value: 2
        },
        {
          id: 4,
          text: 'I don’t know',
          value: 3
        }
      ],
    description: 'Based on 100 studies involving 800,000 participants.',
    impact: 'Studies based on 100+ works involving more than 800,000 people show that diabetes nearly doubles the risk of mortality from all causes.',
    rate: 74,
    link: 'https://www.hindawi.com/journals/jdr/2020/5767582/',
  },
  {
    id: 30,
    type: 'options',
    question: 'Do you have any chronic diseases?',
    options: [
        {
          id: 1,
          text: 'Yes',
          value: 0
        },
        {
          id: 2,
          text: 'I have certain health-related risk factors',
          value: 1
        },
        {
          id: 3,
          text: 'No',
          value: 2
        },
        {
          id: 4,
          text: 'Not sure',
          value: 3
        }
      ],
    description: 'Based on 37 studies.',
    impact: 'Studies based on 37 works on chronic conditions show that they significantly reduce life expectancy.',
    rate: 74,
    link: 'https://journals.plos.org/globalpublichealth/article?id=10.1371/journal.pgph.0000745',
  },
];
